module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/flow_img03-24de64b6634483f1155d66fa4ecb8b4b.svg";